/* HPN native mega menu: mounts desktop panels into the theme header, handles tabs,
   and enhances the theme's mobile drawer (open headings, brand tab links, brand logos). */
(() => {
  const isMobile = () => window.matchMedia('(max-width: 768px)').matches;
  const labelDetails = new Set();

  const activate = (tab) => {
    const root = tab.closest('.hpn-tabs');
    if (!root) return;
    root.querySelectorAll('.hpn-tab.is-active, .hpn-tabs__pane.is-active').forEach((el) => el.classList.remove('is-active'));
    tab.classList.add('is-active');
    const pane = root.querySelector(`[data-hpn-pane="${tab.dataset.hpnTab}"]`);
    if (pane) pane.classList.add('is-active');
  };

  const setupTabs = (root) => {
    const nav = root.querySelector('.hpn-tabs__nav');
    if (!nav) return;
    root.querySelectorAll('.hpn-tabitem > .hpn-tab').forEach((tab) => {
      const li = document.createElement('li');
      li.appendChild(tab);
      nav.appendChild(li);
    });
    const first = nav.querySelector('.hpn-tab');
    if (first) activate(first);
  };

  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  };

  /* ---------- Mobile drawer ---------- */
  const enhanceMobile = (details, panel) => {
    const ul = details.querySelector(':scope > .main-nav__child:not(.hpn-mega) .child-nav');
    if (!ul || ul.dataset.hpnM) return;
    ul.dataset.hpnM = '1';
    const chevron = ul.querySelector('summary .icon');

    // Market subfolders turn "#" into "/en-eu#"; treat those as plain headings too.
    ul.querySelectorAll(':scope > li > nav-menu > details > summary a').forEach((a) => {
      if (!/#$/.test(a.getAttribute('href') || '')) return;
      a.replaceWith(el('span', a.className, a.textContent.trim()));
    });

    // A. Plain headings (link "#") stay open as section labels; repeated labels show once.
    let prev = '';
    ul.querySelectorAll(':scope > li').forEach((li) => {
      const det = li.querySelector(':scope > nav-menu > details');
      const sum = det && det.querySelector(':scope > summary');
      if (!sum || sum.querySelector('a')) { prev = ''; return; }
      const t = sum.textContent.trim().toLowerCase();
      li.classList.add('hpn-m-label');
      if (t === prev) li.classList.add('hpn-m-dup');
      prev = t;
      det.open = true;
      labelDetails.add(det);
      li.addEventListener('click', (e) => {
        if (e.target.closest('summary')) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    });

    // B. Brand tabs become expandable rows with the same links as the desktop tab.
    panel.querySelectorAll('.hpn-tabs__nav .hpn-tab').forEach((tab) => {
      const title = (tab.querySelector('span') || tab).textContent.trim();
      const pane = panel.querySelector(`[data-hpn-pane="${tab.dataset.hpnTab}"]`);
      if (!pane) return;
      const target = [...ul.querySelectorAll(':scope > li')].find((li) => {
        const a = li.querySelector(':scope > a.child-nav__item');
        return a && a.textContent.trim().toLowerCase() === title.toLowerCase();
      });
      if (!target) return;

      const det = el('details');
      const sum = el('summary', 'child-nav__item--toggle main-nav__item--toggle relative');
      const content = el('div', 'main-nav__item-content');
      content.appendChild(el('span', 'main-nav__item child-nav__item', title));
      if (chevron) content.appendChild(chevron.cloneNode(true));
      sum.appendChild(content);
      det.appendChild(sum);

      const wrap = el('div', 'disclosure__panel');
      const list = el('ul', 'main-nav__grandchild');
      list.setAttribute('role', 'list');
      const href = tab.getAttribute('href');
      if (href && href !== '#') {
        const li = el('li');
        const a = el('a', 'grandchild-nav__item main-nav__item hpn-m-all', `Shop all ${title}`);
        a.href = href;
        li.appendChild(a);
        list.appendChild(li);
      }
      let lastHead = '';
      pane.querySelectorAll('.hpn-group').forEach((g) => {
        const h = g.querySelector('.hpn-h');
        const ht = h ? h.textContent.trim() : '';
        if (ht && ht !== lastHead) list.appendChild(el('li', 'hpn-m-sub', ht));
        lastHead = ht;
        g.querySelectorAll('li > a').forEach((src) => {
          const li = el('li');
          const a = el('a', 'grandchild-nav__item main-nav__item', src.textContent.trim());
          a.href = src.getAttribute('href');
          li.appendChild(a);
          list.appendChild(li);
        });
      });
      wrap.appendChild(list);
      det.appendChild(wrap);
      target.textContent = '';
      target.classList.add('hpn-m-brand');
      target.appendChild(det);
    });

    // C. Brand logos as a compact grid at the bottom of the submenu.
    const brands = panel.querySelector('.hpn-brands');
    if (brands && brands.querySelector('.hpn-brand')) {
      const li = el('li', 'hpn-m-brands');
      const h = brands.querySelector('.hpn-h');
      li.appendChild(el('div', 'hpn-m-brands__h', h ? h.textContent.trim() : 'Shop By Brand'));
      const grid = el('div', 'hpn-m-brands__grid');
      brands.querySelectorAll('.hpn-brand').forEach((b) => grid.appendChild(b.cloneNode(true)));
      li.appendChild(grid);
      ul.appendChild(li);
    }
  };

  const reopenLabels = () => labelDetails.forEach((d) => { d.open = true; });

  /* ---------- Mount ----------
     Live site: panels sit in a <template> and are only built the first time a shopper
     hovers, focuses or taps that menu item. Theme editor: everything is built up front. */
  let store = null;

  const build = (d) => {
    if (!d || d.hpnBuilt || !d.hpnSlot) return;
    d.hpnBuilt = true;
    const slot = store && store.content ? document.importNode(d.hpnSlot, true) : d.hpnSlot;
    const panel = slot.querySelector('.hpn-mega');
    if (!panel) return;
    panel.querySelectorAll('.hpn-tabs').forEach(setupTabs);
    d.querySelector(':scope > summary').after(panel);
    enhanceMobile(d, panel);
  };

  const mount = () => {
    store = document.querySelector('.hpn-mega-store');
    if (!store) return;
    document.querySelectorAll('details.hpn-has > .hpn-mega').forEach((old) => old.remove());
    const root = store.content || store;
    const items = {};
    document.querySelectorAll('.main-nav > li > details').forEach((d) => {
      d.classList.remove('hpn-has');
      d.hpnBuilt = false;
      d.hpnSlot = null;
      const a = d.querySelector(':scope > summary a');
      if (a) items[a.textContent.trim().toLowerCase()] = d;
    });
    root.querySelectorAll('.hpn-mega-slot').forEach((slot) => {
      const d = items[slot.dataset.hpnFor];
      if (!d || d.hpnSlot) return;
      d.hpnSlot = slot;
      d.classList.add('hpn-has');
      if (!store.content) build(d);
    });
  };

  const onIntent = (e) => {
    const d = e.target.closest && e.target.closest('.main-nav > li > details');
    if (d && !d.hpnBuilt) build(d);
  };
  ['pointerover', 'focusin', 'touchstart', 'mousedown', 'click'].forEach((type) => {
    document.addEventListener(type, onIntent, { capture: true, passive: true });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('shopify:section:load', mount);
  window.addEventListener('on:breakpoint-change', () => setTimeout(reopenLabels, 0));
  document.addEventListener('click', (e) => {
    if (isMobile() && e.target.closest('.main-nav > li > details > summary')) setTimeout(reopenLabels, 50);
  });

  const onTab = (evt) => {
    const tab = evt.target.closest && evt.target.closest('.hpn-mega .hpn-tab');
    if (tab && !tab.classList.contains('is-active')) activate(tab);
  };
  document.addEventListener('mouseover', onTab);
  document.addEventListener('focusin', onTab);
})();
